export default "__VITE_ASSET__DYFnQ2nC__"